"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopicHandleT = exports.TopicHandle = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
/**
 * A handle for the topic, allows referencing a topic without sending a huge
 * `TopicId`.
 */
class TopicHandle {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTopicHandle(bb, obj) {
        return (obj || new TopicHandle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTopicHandle(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TopicHandle()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    id() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    static startTopicHandle(builder) {
        builder.startObject(1);
    }
    static addId(builder, id) {
        builder.addFieldInt16(0, id, 0);
    }
    static endTopicHandle(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTopicHandle(builder, id) {
        TopicHandle.startTopicHandle(builder);
        TopicHandle.addId(builder, id);
        return TopicHandle.endTopicHandle(builder);
    }
    unpack() {
        return new TopicHandleT(this.id());
    }
    unpackTo(_o) {
        _o.id = this.id();
    }
}
exports.TopicHandle = TopicHandle;
class TopicHandleT {
    constructor(id = 0) {
        this.id = id;
    }
    pack(builder) {
        return TopicHandle.createTopicHandle(builder, this.id);
    }
}
exports.TopicHandleT = TopicHandleT;
